import classNames from "classnames";
import HintArrow from "./HintArrow";

function SwipeHint({ className }) {
  return (
    <div
      className={classNames(
        "h-[30%] w-full flex flex-row justify-evenly items-center",
        className
      )}
    >
      <HintArrow />
      <span className="pxs-swipe-anim font-medium">Swipe</span>
    </div>
  );
}

export default SwipeHint;
